import React, { Component } from 'react';
import zinoImg from 'assets/img//team/avatar.jpg'

class Team extends Component {
    render() {
        return (
            <div>
                <section id="team">
                    <div className="team-top-title">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-4">
                                    <h2 className="section-title">Meet The Team!</h2>
                                </div>
                                <div className="col-md-8">
                                    <p>
                                        {/* We're the guys trying to make this happen :-) */}
                                    </p>
                                </div>
                            </div> {/* END row*/}
                        </div> {/* END container*/}
                    </div> {/* END team-top-title*/}
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-4 col-md-3 no-padding "></div>
                            <div className="col-lg-2 col-md-3 col-sm-6 no-padding wow fadeIn" data-wow-duration="1s" data-wow-delay=".1s">
                                <div className="team-single">
                                    <div className="team-img">
                                        <img src={zinoImg} alt="Dadamuga Mazino" />
                                    </div>
                                    <div className="team-overlay">
                                        <h4>Zeeno</h4>
                                        <p><span role="img" aria-label="Personal Computer">&#x1F4BB;</span>He does the code!</p>
                                        <div className="team-social">
                                            <a href="https://www.facebook.com/ZeenoOfficial/" target="_blank" rel="noopener noreferrer" ><i className="fa fa-facebook" /></a>
                                            <a href="https://twitter.com/deztructicus" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter" /></a>
                                            <a href="https://www.linkedin.com/in/dadamuga-mazino-5b396234/" rel="noopener noreferrer" target="_blank"><i className="fa fa-linkedin" /></a>
                                            <a href="https://www.instagram.com/deztructicus/" rel="noopener noreferrer" target="_blank"><i className="fa fa-instagram" /></a>
                                            <a href="https://www.youtube.com/user/deztructicus" rel="noopener noreferrer" target="_blank"><i className="fa fa-youtube" /></a>
                                        </div>
                                    </div>
                                </div> {/* END team-single*/}
                            </div> {/* END col-lg-3 col-md-6 no-padding*/}

                            <div className="col-lg-2 col-md-3 col-sm-6 no-padding wow fadeIn" data-wow-duration="1s" data-wow-delay=".5s">
                                <div className="team-single">
                                    <div className="team-img">
                                        <img src="assets/img//team/hannah_2.jpg" alt="Hannah Ro" />
                                    </div>
                                    <div className="team-overlay">
                                        <h4>Hannah</h4>
                                        <p>She does the design! <span role="img" aria-label="Cherry Blossom">&#x1F338;</span></p>
                                        <div className="team-social">
                                            <a href="https://twitter.com/oniionz" rel="noopener noreferrer" target="_blank" ><i className="fa fa-twitter" /></a>
                                            <a href="https://www.youtube.com/schroedings" rel="noopener noreferrer" target="_blank" ><i className="fa fa-youtube" /></a>
                                        </div>
                                    </div>
                                </div> {/* END team-single*/}
                            </div> {/* END col-lg-3 col-md-6 no-padding */}
                            <div className="col-lg-4 col-md-0 no-padding "></div>
                        </div> {/* END row*/}
                    </div> {/* END container-fluid*/}
                </section> {/* END team */}
            </div>
        );
    }
}

export default Team;


// WEBPACK FOOTER //
// ./src/components/synthcity/landing/Team.js